import createOidcMiddleware from 'redux-oidc';
import { userManagerPromise } from '../../oidc/userManager';

async function createMiddleware() {
    return createOidcMiddleware(await userManagerPromise);
}

export { createMiddleware };



// WEBPACK FOOTER //
// /src/store/middleware/index.js